module.exports = "/images/design.svg?cf64dce45c6b368189ce3fb21408ff7e";